import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useHasServerAccess } from '../hooks/graphql.js';
export function SubscribedOnly({ children }) {
    const isSubscribed = useHasServerAccess();
    if (!isSubscribed) {
        return null;
    }
    return _jsx(_Fragment, { children: children });
}
export function UnsubscribedOnly({ children }) {
    const isSubscribed = useHasServerAccess();
    if (isSubscribed) {
        return null;
    }
    return _jsx(_Fragment, { children: children });
}
//# sourceMappingURL=gates.js.map